import * as React from "react";

const SvgIcnGroupCall = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="evenodd">
            <path d="M12 14a3 3 0 110-6 3 3 0 010 6zm0-1a2 2 0 110-4 2 2 0 010 4zm2.6 2c1.655 0 3.4 1.5 3.4 3.997v.503a.5.5 0 01-1 0v-.503C17 17.4 15.7 16 14.5 16h-5C8.3 16 7 17.3 7 18.997v.503a.5.5 0 01-1 0v-.503C6 16.5 7.745 15 9.4 15h5.2zM17 8a2 2 0 110-4 2 2 0 010 4zm0-1a1 1 0 110-2 1 1 0 010 2zm2.003 2A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-1 0v-.503A2 2 0 0019.003 10H16.5c-.497 0-.5-.5-.5-.5s.003-.5.5-.5h2.503zM7 8a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 100-2 1 1 0 000 2zM4.997 9A2.997 2.997 0 002 11.997v.503a.5.5 0 001 0v-.503A2 2 0 014.997 10H7.5c.497 0 .5-.5.5-.5S7.997 9 7.5 9H4.997z" />
        </g>
    </svg>
);

export default SvgIcnGroupCall;
